"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumnNumberFilterConfig = void 0;
const react_1 = require("react");
// TODO - EN-4809 - remove after table migration
/** @deprecated - Use useNumberColumnFilterSortConfig instead */
const useColumnNumberFilterConfig = () => {
    const getFilterConfig = (0, react_1.useCallback)(({ id }) => ({
        key: id,
        setNumber: ({ low, high }) => ({ field: id, low, high }),
        getNumber: (filters) => { var _a; return (((_a = filters === null || filters === void 0 ? void 0 : filters.numbers) === null || _a === void 0 ? void 0 : _a[id]) || { field: id }); },
    }), []);
    return getFilterConfig;
};
exports.useColumnNumberFilterConfig = useColumnNumberFilterConfig;
